import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, TitleStrategy, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { CustomTitleStrategy } from './shared/components/services/custom-title-strategy.service';
import { GlobalErrorHandler } from './shared/handlers/global-error.handler';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { loadingInterceptor } from './shared/interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    provideNativeDateAdapter(),
    provideHttpClient(withInterceptors([loadingInterceptor, errorInterceptor, authInterceptor])),

    // temp
    // {
    //   provide: IMAGE_CONFIG,
    //   useValue: {
    //     disableImageSizeWarning: true,
    //     disableImageLazyLoadWarning: true,
    //   },
    // },
    // temp
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
